// UK region: everything that differs for this site. Registered in ../regionConfig.js.
export const config = {
  code: 'UK',
  sourceSite: 'digirep-fsh',
  currency: 'GBP',
  moneyPrefix: '£',
  referralReward: 50,
  supportEmail: 'hello@digitalreporting.uk',
  careEmail: 'care@digitalreporting.uk',
  companyIdLabel: 'Company number',
  searchProviderLabel: 'Companies House',
  filingStatusLabels: {
    ch: 'Companies House',
    hmrc: 'HMRC',
  },
  phonePlaceholder: '+44 7700 900000',
  signupSubtitle: 'UK iXBRL managed tagging services',
  accountTypes: [
    { value: 'micro', label: 'Micro-Entity', subtitle: 'FRS 105', price: 25 },
    { value: 'small', label: 'Small Company', subtitle: 'FRS 102 Section 1A', price: 50 },
    { value: 'full', label: 'Standard / Full', subtitle: 'FRS 102 Full', price: 75 },
  ],
  optionalServices: [
    {
      id: 'hmrc_filing',
      title: 'HMRC CT600 iXBRL Filing',
      description: 'We submit your tagged CT600 corporate tax return directly to HMRC',
      price: 50,
    },
    {
      id: 'companies_house_filing',
      title: 'Companies House iXBRL Filing',
      description: 'We submit your iXBRL accounts to Companies House on your behalf',
      price: 25,
    },
  ],
  serviceCatalog: {
    hmrc_filing: { title: 'HMRC CT600 iXBRL Filing', price: 50 },
    companies_house_filing: { title: 'Companies House iXBRL Filing', price: 25 },
  },
  delivery: {
    standard: { label: 'Standard (48 hours)', shortLabel: 'Standard', hours: '48h', surcharge: 0 },
    express: { label: 'Express (24 hours)', shortLabel: 'Express', hours: '24h', surcharge: 25 },
  },
};

// Hostnames that identify this region and the host used for links back to it.
export const hosts = ['ixbrl.digitalreporting.uk', 'preview.digitalreporting.uk'];
export const primaryHost = 'ixbrl.digitalreporting.uk';
